import { RestClient } from "./restClient";

export class FileStorageService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	/**
	 * Upload a file to a specified bucket
	 * @param {string} bucketName -- string, name of the bucket
	 * @param {string} fileName -- string, name of the file
	 * @param {file} file -- file to upload
	 * @param {function} callback
	 */
	uploadFile(bucketName, fileName, file, callback) {
		const formData = new FormData();
		formData.append("upload", file);
		formData.append("bucketName", bucketName);
		formData.append("fileName", fileName);
		const url = "/_fileUpload";

		// If gets passed a callback, executes normally. Otherwise returns promise for use with async/await, etc.
		if (callback) {
			this._restClient.exec_multipartPost(url, formData, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_multipartPost(url, formData, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	/**
	 * Delete a file from a bucket.
	 * @param {string} bucketName -- string, name of the bucket
	 * @param {string} fileName -- string, name of the file
	 * @param {function} callback
	 */
	deleteFile(bucketName, fileName, callback) {
		const url = `/_fileDelete?bucketName=${bucketName}&fileName=${fileName}`;
		if (callback) {
			this._restClient.exec_delete(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_delete(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					} else {
						resolve(result);
					}
				});
			});
		}
	}

	/**
	 * Check if file exists in a bucket.
	 * @param {string} bucketName -- string, name of the bucket
	 * @param {string} fileName -- string, name of the file
	 * @param {function} callback
	 */
	fileExists(bucketName, fileName, callback) {
		const url = `/_fileExists?bucketName=${bucketName}&fileName=${fileName}`;
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					} else {
						resolve(result);
					}
				});
			});
		}
	}
}
